module.exports = __webpack_public_path__ + "static/bg_image-a1bf5b0f966f99660be3e4019930b29d.jpg";